<template>
  <transition name="t-panel">
    <div :class="['t-panel-wrapper', panelCss]">
      <div ref="panel" class="t-panel-container">
        <v-touch
          :swipeOptions="{direction: 'horizontal'}"
          @swipeleft="$emit('close')"
        >
          <div class="t-panel-bounds">
            <ButtonPush
              v-if="showCloseIcon"
              class="t-panel-close"
              icon="icon-close"
              spin="icon-only"
              @click="$emit('close')"
            >
              Close
            </ButtonPush>
            <slot></slot>
          </div>
        </v-touch>
      </div>
    </div>
  </transition>
</template>

<script>
import ButtonPush from './ButtonPush.vue'

export default {
  name: 'Panel',

  props: {
    closer: {
      type: String,
      default: 'icon',
    },
    placement: {
      type: String,
      default: 'left',
    },
  },

  data: function () {
    return {
      showCloseIcon: this.closer == 'icon',
      panelCss: 't-' + this.placement,
    }
  },

  components: {
    ButtonPush,
  },
}
</script>
